/******* RT 4.1 - 6.1 Deployment Update - @MM - 7/16/25 ******/ 
// Global Variables
let productOptions, comparePrice, priceReduction, originalPrice, ppd, initBuyBox = false, 
    purchaseOption, first_variant_id, first_variant_label, first_variant_input, 
    selected_variant_id, selected_variant_input;
    
var is_subscription, 
    is_ncs, 
    is_b2b = determineB2B();

/*** Buy Box RT - Variant Selection Functionality ***/
/*** Created by @MMJ - 6/5/2025 - 1:15 PM ***/
// Show all content related to a variant ID
function showByVariantId(Id) {
  // Set Variant Title
  prod_title = $(`.product-variant-selection.variant-${Id}`).find('.prod-block-title').text();
  
  // Set buy box content to match the first variant and hide the rest.
  $('.buy-block__selection h3').text(prod_title);
  
  // Hide all variant related content
  $('.variant-hide').hide();

  // Display the selected variant content
  $(`.variant-${Id}.variant-hide`).show();
}

function getAllVarIds() {
  let var_arr = [];
  $('.single-option-selector__radio').each(function(i){
    var_arr.push($(this).data('variant-id'));
  })

  return var_arr;
}

// Initialized Buy Box Product Selection (Variant ID Select)
function initProdSelect() {
  // Retrieve Variant ID by URL
  first_variant_id = getUrlParameter('variant');

  // If no variant id is found in the URL, then grab the first selected variant on page load.
  if(first_variant_id === undefined || first_variant_id === null) {
    first_variant_id = $('.single-option-selector__radio:checked').data('variant-id');
  } else {
    // If the variant Id is found in the URL, then trigger a 'check' on it's prospective input.
    first_variant_input = $(`.product-variant-selection.variant-${first_variant_id}`).attr('for');
    setTimeout(()=>{ $(`#${first_variant_input}`).prop('checked', true).trigger('change'); }, 200)
  }

  first_variant_label = $(`.product-variant-selection.variant-${first_variant_id}`);

  $(document).on('click', '.buybox-rt .product-variant-selection', function(){
    selected_variant_input = $(this).attr('for');
    selected_variant_id = $(`#${selected_variant_input}`).data('variant-id');
    showByVariantId(selected_variant_id);
    updatePrice(selected_variant_id);
  });

  showByVariantId(first_variant_id);
  updatePrice(first_variant_id);
  selected_variant_id = first_variant_id;
}

// Initializes the Product Buy Box
function initProdBuyBox() {
  initProdSelect();
  productOptions = $('.product-variant-selection');
  ppd = $(".price-per-day").data("price-per-day");

  prodBuyBoxListeners();
  (determineBasicProduct()) ? updateQty() : '';
  //determineLocation();
  determineQty(verifyQty());
  singlePurchaseOnly();
  is_subscription = (is_b2b || is_ncs) ? false : true;
  adjustPriceReduction(is_subscription);
  changeButtonText(is_subscription);
  initBuyBox = true;

  $(document).on('submit', 'form.buybox-rt__row', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var formData = new FormData(this);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function(res) {
      if (res.ok && typeof addToCartOk === 'function') { addToCartOk(); }
    });
  });
}

// Will convert floats, integers, and strings to a price (if a product has one)
function priceParse(elem, attr, pr) {
  let price; 

  // Find price by attribute attached to an html element.
  price = $(elem).find('.prod-block-variant-price').data(attr).replace(/[^0-9\.-]+/g, "")

  // Add price reduction if the user chooses the subscriptio option.
  pr ? price = (((Number(price))) - ((Number(price)) * pr)) : price = Number(price); 
  
  return ('$' + price.toFixed(2))
}

// Will contain all event listeners for the product buy box
function prodBuyBoxListeners(){
  $(document).ready(function(){
    $('.product-single__form').on('click', '.yotpo-radio-buy-once-container .yotpo-radio-label', function(){
      $('.yotpo-radio-label-input').attr('aria-checked', 'true');
    });

    $(document).on('click', "#ProductSelect-option-0 .product-variant-selection", function() {
      currSelectedProd = $(this);
      updatePrice(selected_variant_id);
      changeButtonText(is_subscription);
      singlePurchaseOnly();
    }).change(function(){
      updatePrice(selected_variant_id);
    })

    $(document).on('click', '.product-single__form .loop-subscription-group-radio', function(){
      is_subscription = true;
      purchaseOption = $(this);
      updatePrice($('.single-option-selector__radio:checked').data('variant-id'));
    });

    $(document).on('click', '.product-single__form .loop-one-time-purchase-option-radio', function(){
      is_subscription = false;
      purchaseOption = $(this);
      updatePrice($('.single-option-selector__radio:checked').data('variant-id'));
    });

    /**$(document).on('click', '.btn--buy-box', function(){
      setTimeout(changeButtonText(is_subscription), 2000);
    })**/

    // Make single purchase as default on Non Contiguous States.
    (is_ncs) ? $('.loop-one-time-purchase-option').trigger('click') : $('.loop-subscription-group').trigger('click')

    /*** Quantity Selector Code Logic ***/
    $(document).on('click', '.quantity_selector .qty__adjust--minus', function(){
      determineQty(verifyQty());
    });

    $(document).on('click', '.quantity_selector .qty__adjust--plus', function(){
      determineQty(verifyQty());
    });

    $('.quantity_selector #Quantity').on('change', function(){
      determineQty(verifyQty());
    })
  })
}

// Will determine if the customer is a b2b customer.
function determineB2B() {
  //console.log('check for B2B customers');
  return $('.b2b-customer').length !== 0 ? true : false;
}

function determineBasicProduct(){
  return ($('.basic-prodcut').length) ? true : false;
}

function singlePurchaseOnly() {
  /** Single Purchase Only **/
  if (is_b2b && initBuyBox != true) {
    // Hide the subscription block from B2B
    setTimeout(()=>{
      $('.loop-one-time-purchase-option').click().change();
      is_subscription = false;
    }, 1000)
  } else if (is_ncs) {
    /** Single purchase first instead of subscription - NCS ***/ 
    $('.loop-one-time-purchase-option').trigger('click').change();
    is_subscription = false;
  }
}

// Quantity Functionality
function updateQty() {
  let qty_Minus = $('.quantity_selector .qty__adjust--minus'),
      qty_Plus = $('.quantity_selector .qty__adjust--plus'),
      qty_Input = $('.quantity_selector #Quantity');
  
  // Disable minus on product buy box on start of page load.
  determineQty(verifyQty());
  
  // Process the selector arrays above to add events to all elements in the Dom
  qty_Minus.click(updateSiblingValueMinus);
  qty_Plus.click(updateSiblingValuePlus);

  function updateValue(e) {
    currentVal = e.target.value;
    determineQty(verifyQty());
  }

  function updateSiblingValueMinus(e) {
    currentVal = $(this).siblings('input').val();
    if(currentVal >= 2) {
      determineQty(verifyQty());
      currentVal = parseInt(currentVal) - 1;
      $(this).siblings('input').val(currentVal)
    } 
  }

  function updateSiblingValuePlus(e) {
    currentVal = $(this).siblings('input').val();
    currentVal = parseInt(currentVal) + 1;
    if(currentVal >= 1) {
      determineQty(verifyQty());
      $(this).siblings('input').val(currentVal)
    }
  }
};

// Will prevent users from leaving a "0" in the quantity selector. And return the value of the quantity selector.
function verifyQty() {
  let q = $('.quantity_selector #Quantity');
  (q.val() == "0") ? (q.val(1)) : '';
  return q.val();
}

// If the user or customer reaches below '2' on the quantity selector, then the minus button will be disabled.
function determineQty(qty) {
  let qtyMinusBtn =  $('.quantity_selector .qty__adjust--minus');
  if(qty < 2) {
    qtyMinusBtn.attr('disabled', 'disabled');
    qtyMinusBtn.addClass('js-qty__disable');
  } else {
    qtyMinusBtn.removeAttr('disabled');
    qtyMinusBtn.removeClass('js-qty__disable');
  }
}

// Adjust Product Price Reduction based on purchase type.
function adjustPriceReduction(pt) {
  pt ? priceReduction = 0.05 : priceReduction = '';
}

// Adjust the product buy box according to the prices, discounts, subscription, and quantity.
function updatePrice(Id) {
  // Will determine if the variant selector is available, and change the PPD according to it (unless there is no PPD).
  if($('#ProductSelect-option-0').length && $(`#price-per-day-${Id}`).data("price-per-day")) {
    ppd = $(`#price-per-day-${Id}`).data("price-per-day");
    ppd = Number(ppd.replace(/[^0-9\.-]+/g, "")).toFixed(2); 
    $(`#price-per-day-${Id}`).text(`($${ppd}/serving)`);
  }

  if(is_subscription) {
    $('.product-variant-selection .variant__compare-price').show();

    // Calculator to adjust ALL PPD values on multivariant products in the mobile buy box
    let ppdValues = [];

    if ($('#ProductSelect-option-0').length) {
      $('.price-per-day').each(function () {
        let raw = $(this).data('price-per-day');
        if (!raw) return;

        // Strip formatting → number
        let numeric = Number(
          raw.toString().replace(/[^0-9.\-]+/g, '')
        );

        // Apply 5% reduction
        let ppd = (numeric * 0.95).toFixed(2);

        ppdValues.push(ppd);

        // Update UI
        $(this).text(`($${ppd}/serving)`);
      });
    }
  } else {
    $('.product-variant-selection .variant__compare-price').hide();

    // Calculator to adjust ALL PPD values on multivariant products in the mobile buy box
    let ppdValues = [];

    if ($('#ProductSelect-option-0').length) {
      $('.price-per-day').each(function () {
        let raw = $(this).data('price-per-day');
        if (!raw) return;

        // Strip formatting → number
        let numeric = Number(
          raw.toString().replace(/[^0-9.\-]+/g, '')
        );

        // Apply 5% reduction
        let ppd = numeric.toFixed(2);

        ppdValues.push(ppd);

        // Update UI
        $(this).text(`($${ppd}/serving)`);
      });
    }
  }

  // Adjust product price according to purchase option selected
  adjustPriceReduction(is_subscription);
  
  comparePrice = priceParse($(`.product-variant-selection.variant-${Id}`), "unit-price", priceReduction);
  originalPrice = priceParse($(`.product-variant-selection.variant-${Id}`), "compare-price", priceReduction);
  newOriginalPrice = priceParse($(`.product-variant-selection.variant-${Id}`), "unit-price", '');
  newSubscriptionPrice = priceParse($(`.product-variant-selection.variant-${Id}`), "unit-price", '0.05');
  $('.loop-subscription-group-price-amount-original').text(newOriginalPrice);
  $(`.variant-${Id} .variant-original-price`).text(originalPrice);
  $(`.variant-${Id} .variant-compare-price`).text(comparePrice);
  $('.loop-subscription-group-price-amount').text(newSubscriptionPrice);
  $('.loop-one-time-purchase-option-price-amount').text(newOriginalPrice);

  // If product variants exist, then update their prices accordingly.
  if(productOptions) {
    updateVariantPrice(); 
  }

  changeButtonText(is_subscription);
} 

// Update variant prices when customers change purchase options
function updateVariantPrice() {
  productOptions.each(function(i){
    $(this).find('.variant__price').text(priceParse(productOptions[i], 'unit-price', priceReduction));
  })
}

// Adjust all the prices on the left of the buy box.
function changePrices(price) {
  $('.prod-block-variant-price p').each(function(){
    $(this).text(price)
  })
}

// Determine if a product page requires a Proposition 65 Warning Text to be displayed.
function determineP65(region) {
  let pw = document.querySelectorAll('.product-warning'), pvs = document.querySelectorAll('.product-variant-selection');

  // Attach event listener to hide the P65 Warning when Jars are selected. (Pushed on Dev: 08/14/24 - @MMJ)
  if(region !== 'California') {
    pw.forEach(function(el){
      el.classList.add('hide');
    })
  }
  
  // Show P65 to Customers in California.
  region == 'California' ? pw.classList.remove('hide') : ''
}

function isNonContiguousUSA(country, region) {
  let isNonContiguous = false;
  
  if(country != 'US') {
    isNonContiguous = true;
  } else if(country === 'US') {
    if(region === 'Alaska' || region === 'Hawaii') {
      isNonContiguous = true;
    }
  }

  return isNonContiguous;
}

// Function to wrap jQuery.get in a Promise
function fetchIpInfo() {
  return new Promise((resolve, reject) => {
    jQuery.get("https://ipinfo.io", function(response) {
      resolve(response);
    }, "jsonp").fail(function(jqXHR, textStatus, errorThrown) {
      reject(new Error(`Request failed: ${textStatus}`));
    });
  });
}

// Helps determine the whether the button text will change according to the subscription.
function changeButtonText(option) {
  let bb_btn = $('.btn--buy-box');

  bb_btn.each(function(){
    let selected_btn = $(this),
        bb_btn_status = selected_btn.data('btn-status');
    if (bb_btn_status == 'pre-order' && $('.btn--preorder').length) {
      selected_btn.text('Pre-order');
    } else if (bb_btn_status == 'sold-out') {
      selected_btn.text('Sold Out');
    } else if(option === true && is_b2b !== true && bb_btn_status !== 'sold-out' && bb_btn_status !== 'pre-order') {
      selected_btn.text('Subscribe & Save');
      selected_btn.data('btn-status', 'subscription');
    } else if (bb_btn_status !== 'sold-out') {
      selected_btn.text('Add to Cart');
      selected_btn.data('btn-status', 'buy-now');
    }
  });
}

// An async call to determine the location of a customer.
async function determineLocation() {
try {
    const response = await fetchIpInfo();
    const { city, country, region } = response;
    
    if(isNonContiguousUSA(country, region)) {
      is_ncs = true;
    } else {
      determineP65(region);
    }
  } catch (error) {
    console.error('Error fetching location:', error);
  }
}

initProdBuyBox();